export default "__VITE_ASSET__B7hvvX0W__"